var modules_5f96f03e = {"container":"_10pt94s","checked":"_1wl4w2h","control":"_1z0buzl","disabled":"_l7mrf6","read-only":"_ishfhe","input":"_1pqd9pr","handler":"_15xcl9n","label":"_vqdp3s"};
import "../../../assets/BZXCoqRE.css";

export { modules_5f96f03e as default };
//# sourceMappingURL=Switch.module.less.js.map
